import { Button, Heading, Paragraph } from '@pandiafi/design-system'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

interface SuccessProps {
  illustration: React.ReactNode
  heading?: string
  text?: string
  buttonAction?: () => void
  buttonText?: string
}

const Success: React.FC<SuccessProps> = ({
  illustration,
  heading,
  text,
  buttonAction,
  buttonText,
}) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const navigate = useNavigate()
  const { frontPagePath } = useContractPaths()

  return (
    <div className="p-10 flex flex-col items-center">
      {illustration}
      {heading && (
        <Heading element="h1" size="l" className="mt-8">
          {heading}
        </Heading>
      )}
      {text && (
        <Paragraph className={heading ? 'mt-2' : 'mt-8'}>{text}</Paragraph>
      )}
      <Button
        className="mt-8"
        type="button"
        variant="primary"
        onClick={() =>
          buttonAction
            ? buttonAction()
            : navigate(frontPagePath, { replace: true })
        }
      >
        {buttonText || t('common:backToHome')}
      </Button>
    </div>
  )
}

export default Success
